'use es6';

import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/CrmSearch';
export function propertyNames(state = {}, action) {
  switch (action.type) {
    case Actions.CLEANUP_ANALYSE_DATA:
      return {};
    default:
      return state;
  }
}
export function propertyValues(state = {}, action) {
  switch (action.type) {
    case Actions.REQUEST_FORM_SUBMISSIONS_PROPERTY_VALUE:
      {
        const {
          propertyName,
          propertyValue,
          dateRange,
          offset
        } = action.params;
        return Object.assign({}, state, {
          [JSON.stringify({
            propertyName,
            propertyValue,
            dateRange,
            offset
          })]: {
            requestState: RequestState.REQUESTED
          }
        });
      }
    case Actions.RECEIVE_FORM_SUBMISSIONS_PROPERTY_VALUE:
      {
        const {
          propertyName,
          propertyValue,
          dateRange,
          hasMore,
          offset,
          conversionIds,
          submissions,
          total
        } = action.response;
        return Object.assign({}, state, {
          [JSON.stringify({
            propertyName,
            propertyValue,
            dateRange,
            offset
          })]: {
            conversionIds,
            submissions,
            total,
            hasMore,
            requestState: RequestState.SUCCEEDED
          }
        });
      }
    case Actions.FAIL_GETTING_FORM_SUBMISSIONS_PROPERTY_VALUE:
      {
        const {
          propertyName,
          propertyValue,
          dateRange,
          offset
        } = action.params;
        return Object.assign({}, state, {
          [JSON.stringify({
            propertyName,
            propertyValue,
            dateRange,
            offset
          })]: {
            requestState: RequestState.FAILED
          }
        });
      }
    case Actions.CLEANUP_ANALYSE_DATA:
      return {};
    default:
      return state;
  }
}
export function propertyAggregations(state = {}, action) {
  const {
    aggregations,
    fields,
    dateRange
  } = action;
  switch (action.type) {
    case Actions.REQUEST_PROPERTY_AGGREGATIONS:
      {
        return Object.assign({}, state, ...fields.map(field => ({
          [JSON.stringify({
            field,
            dateRange
          })]: {
            requestState: RequestState.REQUESTED
          }
        })));
      }
    case Actions.RECEIVE_PROPERTY_AGGREGATIONS:
      return Object.assign({}, state, ...aggregations.map(aggregation => {
        return {
          [JSON.stringify({
            field: aggregation.field,
            dateRange
          })]: {
            breakdown: aggregation.breakdown,
            requestState: RequestState.SUCCEEDED
          }
        };
      }));
    case Actions.FAIL_FETCHING_PROPERTY_AGGREGATIONS:
      return Object.assign({}, state, ...fields.map(field => ({
        [JSON.stringify({
          field,
          dateRange
        })]: {
          requestState: RequestState.FAILED
        }
      })));
    case Actions.CLEANUP_ANALYSE_DATA:
      return {};
    default:
      return state;
  }
}
export function propertyFrequencies(state = {}, action) {
  const {
    offset,
    includeRequiredFields,
    dateRange
  } = action;
  switch (action.type) {
    case Actions.REQUEST_FORM_SUBMISSIONS_PROPERTY_FREQUENCIES:
      return Object.assign({}, state, {
        [JSON.stringify({
          offset,
          includeRequiredFields,
          dateRange
        })]: {
          frequencies: {},
          total: 0,
          requestState: RequestState.REQUESTED
        }
      });
    case Actions.SUCCEED_GETTING_FORM_SUBMISSIONS_PROPERTY_FREQUENCIES:
      return Object.assign({}, state, {
        [JSON.stringify({
          offset,
          includeRequiredFields,
          dateRange
        })]: {
          frequencies: action.response.results,
          total: action.response.total,
          requestState: RequestState.SUCCEEDED
        }
      });
    case Actions.FAIL_GETTING_FORM_SUBMISSIONS_PROPERTY_FREQUENCIES:
      return Object.assign({}, state, {
        [JSON.stringify({
          offset,
          includeRequiredFields,
          dateRange
        })]: {
          frequencies: {},
          total: 0,
          requestState: RequestState.FAILED
        }
      });
    case Actions.CLEANUP_ANALYSE_DATA:
      return {};
    default:
      return state;
  }
}